import { render, staticRenderFns } from "./ComponentSectionTitle.vue?vue&type=template&id=7761bfd6&scoped=true&"
import script from "./ComponentSectionTitle.vue?vue&type=script&lang=js&"
export * from "./ComponentSectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./ComponentSectionTitle.vue?vue&type=style&index=0&id=7761bfd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7761bfd6",
  null
  
)

export default component.exports